import { Steps } from './Steps';

export const navigationStepsOrder: Steps[] = [
  Steps.YourVehicle,
  Steps.SelectService,
  Steps.SelectDealer,
  // Steps.EstimatedPrice,
  Steps.Appointment,
  // Steps.CollectionAndDelivery,
  Steps.ContactDetails,
  Steps.ReviewAndSubmit,
];
